import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import BulkImportRecordsGrid from '../../components/grids/BulkImportRecordsGrid';
import Button from '../../../../components/form/Button';
import { fetchAndExportToXlsx } from '../../../../components/Grid/exportGrid';
import { getDecodedUser } from '../../../../utils/login';
import { ColumnType } from '../../../../components/Grid/constants';
import { generateHandoverProtocolOfficialWorkingPosition } from "../../CroActions";
import {ReleasedType} from "../../enum";

const GRID_NAME = 'bulkImportRecordsGrid';

const releasedMapper = (value) => {
  if (value === 'RELEASED') return 'Uvolněný';
  if (value === 'NOT_RELEASED') return 'Neuvolněný';
  return value || '';
};

const exportColumns = [
  { field: 'titleBefore', label: 'Titul před', type: ColumnType.TEXT },
  { field: 'firstName', label: 'Jméno', type: ColumnType.TEXT },
  { field: 'middleName', label: 'Další jména', type: ColumnType.TEXT },
  { field: 'lastName', label: 'Příjmení', type: ColumnType.TEXT },
  { field: 'titleAfter', label: 'Titul za', type: ColumnType.TEXT },
  { field: 'birthDate', label: 'Datum narození', type: ColumnType.DATE },
  { field: 'birthCountry', label: 'Stát narození', type: ColumnType.TEXT },
  { field: 'birthMunicipality', label: 'Obec narození', type: ColumnType.TEXT },
  { field: 'email', label: 'Email', type: ColumnType.TEXT },
  { field: 'workingPosition', label: 'Funkce', type: ColumnType.TEXT },
  { field: 'released', label: 'Uvolněnost', type: ColumnType.ENUM, enum: ReleasedType, displayField: 'released', mapper: releasedMapper, exportValue: (row) => releasedMapper(row.released) },
  { field: 'organization', label: 'Organizace', type: ColumnType.TEXT },
  { field: 'start', label: 'Datum zahájení výkonu funkce', type: ColumnType.DATE },
  { field: 'end', label: 'Datum ukončení výkonu funkce', type: ColumnType.DATE },
  { field: 'dateOfStart', label: 'Datum předání informace o zápisu zahájení', type: ColumnType.DATE },
  { field: 'dateOfEnd', label: 'Datum předání informace o zápisu ukončení', type: ColumnType.DATE },
  { field: 'username', label: 'Přihlašovací jméno', type: ColumnType.TEXT },
  { field: 'password', label: 'Heslo', type: ColumnType.TEXT },
  { field: 'note', label: 'Poznámka', type: ColumnType.TEXT },
];

class BulkImportDetail extends Component {
  state = { exporting: false };

  componentWillMount() {
    this.props.breadcrumbs([
      { label: 'Přehled hromadných zápisů', onClick: () => this.props.push(`${this.props.auth.startUrl}/hromadne-zapisy`) },
      { label: 'Detail hromadného zápisu' },
    ]);
  }

  onExport = async () => {
    const { auth, params, gridState } = this.props;
    const batchId = params.id;
    this.setState({ exporting: true });
    try {
      await fetchAndExportToXlsx({
        url: `${auth.startUrl}/api/hromadne-zapisy/${batchId}/zaznamy`,
        columns: exportColumns,
        filters: gridState ? gridState.filters : [],
        sort: gridState ? gridState.sort : 'created',
        order: gridState ? gridState.order : 'DESC',
        query: gridState ? gridState.query : null,
        filename: `hromadny-zapis-${batchId}.xlsx`,
      });
    } catch (e) {
      console.error('Export failed:', e);
    } finally {
      this.setState({ exporting: false });
    }
  };

  handleHandoverProtocol = (officialId, workingPositionId, type) => {
    generateHandoverProtocolOfficialWorkingPosition(officialId, workingPositionId, type, this.props.dispatch)
  }

  render() {
    const { auth, params } = this.props;
    const { exporting } = this.state;
    const batchId = params.id;

    const ExportButton = (
      <Button
        key="export"
        type="button"
        label={exporting ? 'Exportování...' : 'Export do Excelu'}
        disabled={exporting}
        style={{ color: 'white', marginRight: 10, padding: '0px 15px' }}
        onTouchTap={this.onExport}
      />
    );

    return (
      <BulkImportRecordsGrid
        gridName={GRID_NAME}
        url={`${auth.startUrl}/api/hromadne-zapisy/${batchId}/zaznamy`}
        toolbarButtons={[ExportButton]}
        handleHandoverProtocol={this.handleHandoverProtocol}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const user = getDecodedUser();
  const fullGridName = `${GRID_NAME}_${user ? user.sub : 'notLogged'}`;
  return {
    gridState: state.grid[fullGridName] || null,
  };
};

export default connect(mapStateToProps, { breadcrumbs, push })(BulkImportDetail);
